import { createContext, useContext, useEffect } from "react";
export const WelcomeHaniContext = createContext<{
  continueLearning: () => boolean;
  register: () => () => void;
} | null>(null);

/** A mounted Welcome Back surface registers independently of loading-map/content swaps. */
export function useWelcomeHaniGreeting() {
  const context = useContext(WelcomeHaniContext);
  useEffect(() => context?.register(), [context]);
  return context?.continueLearning;
}
